import log from "loglevel"
import { forceBooleanIfExists } from '@avlino-inc/alenza-core'

// NOTE: Added to prevent error on dev mode, and throw error in production mode if file is not created!
if (!window._env_) {
  if (process.env.NODE_ENV === "development") {
    log.warn(
      `'window._env_' was not set! Are you using 'npm run dev'? Using 'process.env' through webpack. These values are baked into the build and cannot be changed at runtime.`
    );
    window._env_ = process.env;
  } else {
    throw new Error(
      "window._env_ was not set! You are required to create a env-setup.js file in a production deployment/build!"
    );
  }
}

function filterOutEmptyStrings(obj) {
	return Object.fromEntries(
		Object.entries(obj).reduce(
			(list, [key, value]) => {
				if(
					!value
					|| value.trim().length === 0
					|| value.trim() === `''`
					|| value.trim() === `""`
				){
					console.log(`Removed empty string ${key} => "${value}" from env.`)
					return list
				}

				list.push([key, value])
				return list
			},
			[]
		)
	)
}

const filteredEnv = filterOutEmptyStrings(window._env_)

export const isProduction = filteredEnv.REACT_APP_PRODUCTION_BUILD;
export const protocol = filteredEnv.REACT_APP_PROTOCOL;
export const forceRelativeHost = forceBooleanIfExists(filteredEnv.REACT_APP_API_FORCE_RELATIVE_HOST);
export const apiHost = forceRelativeHost === true
	? window.location.host 
	: (filteredEnv.REACT_APP_API_HOST ?? window.location.host);
export const apiVersion = filteredEnv.REACT_APP_API_VERSION;
export const theme = filteredEnv.REACT_APP_THEME;
export const kibanaUrl = filteredEnv.REACT_APP_KIBANA_URL;
export const forceAlenzaConfigPage = filteredEnv.REACT_APP_CONFIG_PAGE_FORCE_ALENZA;
export const gaTrackingCode = filteredEnv.REACT_APP_GA_TRACKING_CODE;

log.info(`Is Production Deploy: ${isProduction}`);
log.info(`Protocol: ${protocol}`);
log.info(`Force Relative Host: ${forceRelativeHost}`);
log.info(`API Host: ${apiHost}`);
log.info(`API Version: ${apiVersion}`);
log.info(`Theme: ${theme}`);
log.info(`Kibana URL: ${kibanaUrl}`);
log.info(`Force Alenza Config Page: ${forceAlenzaConfigPage}`);
log.info(`GoogleAnalytics Tracking Code: ${gaTrackingCode}`);

// Some endpoints are modified based on the current theme (Aicon, Aircell, etc)
// However, most endpoints will import and use 'apiCoreEndpoint' variable
export const generateApiThemeEndpoint = (theme) => {
  const themeLower = theme.toLowerCase();
  if (themeLower !== "alenza") {
    return `${protocol}://${apiHost}/api/${apiVersion}/${themeLower}/core`;
  } else {
    return `${protocol}://${apiHost}/api/${apiVersion}/core`;
  }
};
export const apiThemeEndpoint = generateApiThemeEndpoint(theme);
export const apiRootEndpoint = `${protocol}://${apiHost}/api/${apiVersion}`;
export const apiCoreEndpoint = `${protocol}://${apiHost}/api/${apiVersion}/core`;
export const ymsapiCoreEndpoint = `${protocol}://${apiHost}/api/${apiVersion}/aicon/yms`;

log.info(`API Root: ${apiCoreEndpoint}`);
log.info(`AiCON API Root: ${ymsapiCoreEndpoint}`);

// Roles
export const administratorRoleId = 1;
export const accountOwnerRoleId = 2;
export const teamLeaderRoleId = 3;
export const memberRoleId = 4;
